import React from "react";
import {css, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {Container} from "@pg-design/grid-module";
import {
    backgroundColor,
    calculateRemSize,
    display,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    maxWidth,
    mb,
    mv,
    onDesktop,
    position,
    zIndex
} from "@pg-design/helpers-css";
import {CheckIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {IconWithElement} from "./IconWithElement";

const illustration = require("../images/first_of_section.svg");
const paragraphs = [
    "całkowicie darmowe narzędzia do oszacowania scoringu kredytowego i symulacji kredytu hipotecznego,",
    "bezpieczne rozwiązania, które chronią Twoje dane,",
    "zaufane źródło informacji i pierwsza linia kontaktu z najlepszymi ekspertami kredytowymi na rynku."
];

export const CreditCalculatorFirstOfSecton = () => {
    const {isMobile} = useUserDevice();
    const theme = useTheme();

    const imageHeight = isMobile ? 187 : 372;
    const iconProps = {
        size: "3.2",
        wrapperSize: "3.2",
        wrapperColor: theme.colors.primary
    };

    return (
        <Container css={sectionWrapper}>
            <div>
                <Text as="p" variant="headline_4" css={[mb(1), onDesktop(mb(3.5))]}>
                    Kalkulatory zdolności kredytowej i raty kredytu rynekpierwotny.pl to:
                </Text>

                {paragraphs.map((paragraph, index) => (
                    <IconWithElement key={index} icon={CheckIcon} containerStyle={iconWitchElementStyle} iconProps={iconProps}>
                        <Text variant="body_copy_0">{paragraph}</Text>
                    </IconWithElement>
                ))}
            </div>

            <StyledImage
                src={illustration}
                alt="W pierwszej kolejności dowiedz się:"
                width={isMobile ? "235" : "468"}
                height={imageHeight.toString()}
                circleSize={imageHeight - (isMobile ? 5 : 10)}
            />
        </Container>
    );
};

const sectionWrapper = css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(3)};
    ${mv(3)};

    ${onDesktop(css`
        ${flexDirection("row")}
        gap: ${calculateRemSize(16)};
        ${mv(12)};
    `)};
`;

const iconWitchElementStyle = css`
    ${flex("flex-start", "flex-start")};
    ${flexDirection("row")};
    gap: ${calculateRemSize(2)};
    ${mb(1)};

    ${onDesktop(maxWidth("480px"))};
`;

const StyledImage = styled(Image)<{circleSize: number}>`
    ${position("relative")};
    ${zIndex(0)};

    &::after {
        content: "";
        ${display("block")};
        width: ${(props) => `${props.circleSize}px`};
        height: ${(props) => `${props.circleSize}px`};
        ${(props) => backgroundColor(props.theme.colors.primary)};
        border-radius: 50%;
        ${position("absolute")};
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        ${zIndex(-1)};
    }
`;
import React from "react";
import {css, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {Container} from "@pg-design/grid-module";
import {
    backgroundColor,
    calculateRemSize,
    display,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    maxWidth,
    mb,
    mv,
    onDesktop,
    position,
    zIndex
} from "@pg-design/helpers-css";
import {CheckIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {IconWithElement} from "./IconWithElement";

const illustration = require("../images/first_of_section.svg");
const paragraphs = [
    "całkowicie darmowe narzędzia do oszacowania scoringu kredytowego i symulacji kredytu hipotecznego,",
    "bezpieczne rozwiązania, które chronią Twoje dane,",
    "zaufane źródło informacji i pierwsza linia kontaktu z najlepszymi ekspertami kredytowymi na rynku."
];

export const CreditCalculatorFirstOfSecton = () => {
    const {isMobile} = useUserDevice();
    const theme = useTheme();

    const imageHeight = isMobile ? 187 : 372;
    const iconProps = {
        size: "3.2",
        wrapperSize: "3.2",
        wrapperColor: theme.colors.primary
    };

    return (
        <Container css={sectionWrapper}>
            <div>
                <Text as="p" variant="headline_4" css={[mb(1), onDesktop(mb(3.5))]}>
                    Kalkulatory zdolności kredytowej i raty kredytu rynekpierwotny.pl to:
                </Text>

                {paragraphs.map((paragraph, index) => (
                    <IconWithElement key={index} icon={CheckIcon} containerStyle={iconWitchElementStyle} iconProps={iconProps}>
                        <Text variant="body_copy_0">{paragraph}</Text>
                    </IconWithElement>
                ))}
            </div>

            <StyledImage
                src={illustration}
                alt="W pierwszej kolejności dowiedz się:"
                width={isMobile ? "235" : "468"}
                height={imageHeight.toString()}
                circleSize={imageHeight - (isMobile ? 5 : 10)}
            />
        </Container>
    );
};

const sectionWrapper = css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(3)};
    ${mv(3)};

    ${onDesktop(css`
        ${flexDirection("row")}
        gap: ${calculateRemSize(16)};
        ${mv(12)};
    `)};
`;

const iconWitchElementStyle = css`
    ${flex("flex-start", "flex-start")};
    ${flexDirection("row")};
    gap: ${calculateRemSize(2)};
    ${mb(1)};

    ${onDesktop(maxWidth("480px"))};
`;

const StyledImage = styled(Image)<{circleSize: number}>`
    ${position("relative")};
    ${zIndex(0)};

    &::after {
        content: "";
        ${display("block")};
        width: ${(props) => `${props.circleSize}px`};
        height: ${(props) => `${props.circleSize}px`};
        ${(props) => backgroundColor(props.theme.colors.primary)};
        border-radius: 50%;
        ${position("absolute")};
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        ${zIndex(-1)};
    }
`;
